export default {"loader":"sdZ3K","mulShdSpin":"cFr3Y"};